import { FC, useState } from "react";
import { TabPanel, Tabs } from "../../TrueUI";
import UsersAndPermissions from "./UsersAndPermissions/UsersAndPermissions";

import SSOManagement from "./SSOManagement";

const AdminSecurity: FC = () => {
  const [value, setValue] = useState(0);
  return (
    <div style={{ width: "100%" }}>
      <Tabs
        name={"security_tabs"}
        onSelect={(selected) => {
          setValue(selected.selected);
        }}
        selected={value}
      >
        <TabPanel title={"Users and Permissions"} key="1">
          <UsersAndPermissions />
        </TabPanel>
        <TabPanel title={"SSO Management"} key="2">
          <SSOManagement />
        </TabPanel>
      </Tabs>
    </div>
  );
};

export default AdminSecurity;
